import { Button, Modal, Form, Row, Col, Input, message } from "antd";
import { useEffect, useState } from "react";
import patchDataTrace from "../../../../services/patchDataTrace";

export default function UpdateRole({
  isVisible,
  setVisible,
  selected,
  refetch,
}: any) {
  const [isLoading, setLoading] = useState(false);

  const [form] = Form.useForm();

  const onSubmit = async () => {
    setLoading(true);
    const { name } = await form.getFieldsValue();

    const data = { name };
    const uri = `roles/${selected?._id}`;
    const response = await patchDataTrace(data, uri);
    if (response.success) {
      message.success("Updated Successfully");
      refetch();
      form.resetFields();
      setVisible(false);
    } else {
      message.error(response.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    form.resetFields();
  }, [selected]);

  return (
    <Modal
      visible={isVisible}
      title="Update Role"
      onCancel={() => setVisible(!isVisible)}
      footer={[
        <Button danger key="back" onClick={() => setVisible(!isVisible)}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="createRole"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="createRole"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="name"
              initialValue={selected?.name}
              rules={[
                {
                  required: true,
                  message: "Please enter role",
                },
              ]}
            >
              <Input placeholder="Role" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
